import { MappingApi } from '../../../../../api/mappingApi';
import { TemplatesApi } from '../../../../../api/templatesApi';
import { BatchDeterminationContext } from '../../../../../contexts/BatchDeterminationContext';
import { AdvancedOptions, MappingInfo } from '../../../../../interfaces/Mapping';
import { SnackbarParameters } from '../../../../../interfaces/Snackbar';
import { Template } from '../../../../../interfaces/Templates';
import withSnackbar from '../../../../../shared/components/withSnackbar';
import { SovosButton, SovosDialog, SovosDialogActions, SovosDialogContent, SovosDialogTitle } from 'mosaic-react';
import { useContext } from 'react';

interface UpdateTemplateDialogProps {
	isDialogOpen: boolean;
	mappedColumns: MappingInfo[];
	selectedTemplate: Template;
	advancedOptions: AdvancedOptions;
	onCloseDialog: () => void;
	showSnackbar: (value: SnackbarParameters) => void;
}

const UpdateGlobalTemplateDialog = (props: UpdateTemplateDialogProps) => {
	const { isDialogOpen, onCloseDialog, mappedColumns, showSnackbar, selectedTemplate, advancedOptions } = props;
	const { onClose } = useContext(BatchDeterminationContext);

	const handleSave = async (): Promise<void> => {
		onCloseDialog();
		try {
			const responseUpdateMapping = await MappingApi.updateMappedColumns(
				selectedTemplate.mapping?.id!,
				advancedOptions.calculationType,
				mappedColumns,
				'G'
			);

			if (responseUpdateMapping.status === 200) {
				const responseUpdateProfile = await TemplatesApi.updateTemplate(
					{ ...selectedTemplate, ...advancedOptions, scope: 'G', version: 1 },
					selectedTemplate.ruleType!,
					selectedTemplate.mapping?.id!
				);

				if (responseUpdateProfile.status === 200) {
					showSnackbar({
						message: 'Template updated successfully',
						variant: 'confirmation',
					});
					setTimeout(() => onClose(), 2000);
				} else {
					showSnackbar({
						message: responseUpdateProfile.data.errors[0].message,
						variant: 'error',
					});
				}
			} else {
				showSnackbar({
					message: responseUpdateMapping.data.errors[0].message,
					variant: 'error',
				});
			}
		} catch (error: any) {
			showSnackbar({ message: error.toString(), variant: 'error' });
		}
	};

	return (
		<SovosDialog open={isDialogOpen} onClose={onCloseDialog}>
			<SovosDialogTitle className='custom-title'>Save changes to this global template?</SovosDialogTitle>
			<SovosDialogContent>
				<p>
					Saving changes to the global template will overwrite the default template settings. This will impact all Batch
					users across all organizations and should only be made in consultation with the Batch Product Team.
				</p>
				<p>Are you sure you want to continue?</p>
			</SovosDialogContent>
			<SovosDialogActions>
				<SovosButton variant='text' onClick={onCloseDialog}>
					Cancel
				</SovosButton>
				<SovosButton onClick={handleSave} color='error'>
					Save
				</SovosButton>
			</SovosDialogActions>
		</SovosDialog>
	);
};

export default withSnackbar(UpdateGlobalTemplateDialog);
